import { render, staticRenderFns } from "./operate-table-details.vue?vue&type=template&id=74ea5922&scoped=true&"
import script from "./operate-table-details.vue?vue&type=script&lang=js&"
export * from "./operate-table-details.vue?vue&type=script&lang=js&"
import style0 from "./operate-table-details.vue?vue&type=style&index=0&id=74ea5922&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ea5922",
  null
  
)

export default component.exports